import { useQuery } from '@tanstack/react-query';
import type { CategoryDefDto, LookupListDto } from '@tww/shared';
import { api } from './client';

export function useLookups() {
  return useQuery({
    queryKey: ['lookups'],
    queryFn: () => api.get<{ items: LookupListDto[] }>('/lookups').then((r) => r.items),
    staleTime: 60_000,
  });
}
export function useLookup(key: string) {
  const q = useLookups();
  const list = q.data?.find((l) => l.key === key);
  return { ...q, list, values: (list?.values ?? []).filter((v) => v.is_active) };
}
export function useCategoryDefs() {
  return useQuery({
    queryKey: ['contact-categories'],
    queryFn: () => api.get<{ items: CategoryDefDto[] }>('/contact-categories').then((r) => r.items),
    staleTime: 60_000,
  });
}
